import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '../store'

import { getReferral } from './apiAction/getReferral'
import { initialState } from './initialReferralState'
import { IReferralState } from './interface/IReferralState'

export const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getReferral.pending, state => ({
      ...state,
      status: 'loading',
    }))
    builder.addCase(getReferral.rejected, (state, action) => ({
      ...state,
      status: 'failed',
      error: action.payload
        ? action.payload.message
        : 'Getting referrals failed',
    }))
    builder.addCase(getReferral.fulfilled, (state, action) => {
      state.list = action.payload
      return state
    })
  },
})

export const referralStateSelector = (state: RootState): IReferralState =>
  state.referral

export const referralListSelector = (state: RootState) =>
  referralStateSelector(state).list
export default referralSlice.reducer
